/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(id) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetExamPeriodByID: {
        $xmlns: 'http://dobs.pa.gov/nd/exam/bpm/1.0',
        ID: id
      }
    },
    blueprint: {
      id: '$..ID',
      yearPeriod: '$..YearPeriod',
      createdDate: '$..CreatedDate',
      startDate: '$..StartDate',
      endDate: '$..EndDate'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.startDate = moment(response.startDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
      response.endDate = moment(response.endDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
